import { ApplicationRef, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from './notification';
import { ComponentheaderService } from '../componentheader.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NotificationInterceptor implements HttpInterceptor {

  private suspendNotification = false;
  get SuspendNotification(){
    return this.suspendNotification;
  }
  set SuspendNotification(value){
    this.suspendNotification = value;
  }

  constructor( private toastr : ToastrService, private notification :NotificationService, private headerinfo: ComponentheaderService, private router: Router, private ref: ApplicationRef)  {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(            
      catchError((error : any/*HttpErrorResponse*/) => {   
        //debugger
        console.log(error);
        if(!this.SuspendNotification){
          if(error.status === 0){
            this.showError("Unable to connect to server", "Connection Error", 5000);
          }
          else if(error.status === 400){   
            this.showError(error, "Error", 8000);
          }
          else if(error.status === 401){
            this.showError('Authentication failed', "Error", 5000);
            this.router.navigate(['/logout']);
          }
          else{
            this.showError(error);
          }
          this.headerinfo.pageLoadingError();
        }

        //in some cases, (e.g. when there is an error registering via the login with google popup), the toastr doesn't display because the user is not on the page (i.e. the user is actually on the popup)
        //in that cases, the tick forces an update which appears to cause the toastr to be rendered in html properly properly (except for the opacity and display for some reason)
        //the opacity = 1 and display = 'block' had to be added for it to display

        this.ref.tick();

        setTimeout(() => {
          const toastrdiv: any = document.querySelector('#toast-container > div');
          toastrdiv.style.opacity = 1;
          toastrdiv.style.display = 'block';
        });

        return throwError(error);
      })
    );

  }

  showError(error, title = 'Error', timeout = 5000){
    if(typeof error === 'string'){
      this.toastr.error(error, title, { timeOut : timeout });      
    }
    else{
      if(error.error && error.error.message){
        this.showError(error.error.message, title, timeout);
      }
      else if(error.error && error.error.errors  && Object.keys(error.error.errors).length > 0){
        for(let item in error.error.errors){
          const errormessages: string[] = error.error.errors[item];
          errormessages.forEach(errormessage => {
            //this.toastr.error(errormessage, `Error: ${item}`);
            this.showError(errormessage, item, timeout);
          });
        }
      }
      else if(error.message){
        this.showError(error.message, title, timeout);
      }
      
      else{
        this.showError('Unexpected Error', title, timeout);
      }
    }
  }
}
